import "./../../Home/assets/css/fontawesome.css";
import "./../../Home/assets/css/templatemo-finance-business.css";
import "./../../Home/assets/css/owl.css";
import React, {useState} from "react";

import { AboutComponentMessages } from "./AboutComponentMessages";
import { Container,Row,Col } from "react-bootstrap";

import team1 from './../../Home/assets/images/team_01.jpg';
import team2 from './../../Home/assets/images/team_02.jpg';




const AboutComponent = props => {

    return(
   <>
    <div class="page-heading header-text">
        <div class="container">
            <div class="row">
            <div class="col-md-12">
                <h1>About Us</h1>
                <span>We have over 40 years of combined software experience</span>
            </div>
            </div>
        </div>
    </div>

    <div class="team">   
        <Container>
            <Row> 
                <div class="section-heading">
                    <h2>Our team</h2>
                </div>
            </Row>
            <Row>
                <Col>
                    <div class="team-item">
                        <img src={team1} alt=""/>
                        <div class="down-content">
                            <h4>Darryl Nicholson</h4>
                            <span>Co-Founder</span>
                            <p>After leaving British Columbia and Nortel in the rearview mirror, Darryl came to Oregon to be immersed in the start up world! After completing exits with Janrain and Legit Script he's ready to start his next adventure.</p>
                        </div>
                    </div>
                </Col>
                <Col>
                    <div class="team-item">
                        <img src={team2} alt=""/>
                        <div class="down-content">
                            <h4>Mark Watson</h4>
                            <span>Co-Founder</span>
                            <p>After a decade in broadcasting Mark made his way to Oregon to join Intel. After starting his own company providing software to MLB and NHL teams, he's ready to start his next adventure.</p>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
        <br></br>
    </div>
    </>
    );
}

AboutComponent.defaultProps = {

}
AboutComponent.propTypes = {

}

export default (AboutComponent);